import React from 'react';
import {
  ADMISSION_TEST_LABELS,
  SCORE_PLACEHOLDERS
} from '../constants/admissionTests';

export default function AdmissionTestsFields({
  value,
  onChange,
  disabled = false,
  readOnly = false
}) {
  const tests = value || {};

  const handleChange = (testKey, field, fieldValue) => {
    if (disabled || readOnly || !onChange) return;
    const prev = tests[testKey] || { attempted: '', score: '', date: '' };
    const next = { ...prev, [field]: fieldValue };
    if (field === 'score' || field === 'date') {
      next.attempted = (next.score || next.date) ? 'Yes' : '';
    }
    onChange({
      ...tests,
      [testKey]: next
    });
  };

  return (
    <div className="admission-tests-fields">
      <label className="section-label-orange">English / Admission Tests</label>
      <div className="admission-tests-table">
        <div className="admission-tests-header">
          <span>Test</span>
          <span>Score</span>
          <span>Date/Month/Year of Test</span>
        </div>
        {Object.entries(ADMISSION_TEST_LABELS).map(([key, label]) => {
          const row = tests[key] || { attempted: '', score: '', date: '' };
          return (
            <div key={key} className="admission-test-row">
              <span className="test-name">{label}</span>
              <div className="admission-field">
                <span className="admission-field-label">Score</span>
                <input
                  type="text"
                  placeholder={SCORE_PLACEHOLDERS[key]}
                  value={row.score || ''}
                  onChange={(e) => handleChange(key, 'score', e.target.value)}
                  disabled={disabled || readOnly}
                  readOnly={readOnly}
                />
              </div>
              <div className="admission-field">
                <span className="admission-field-label">Date/Month/Year of Test</span>
                <input
                  type="text"
                  placeholder="e.g. 2024, Mar 2024, or 15 Mar 2024"
                  value={row.date || ''}
                  onChange={(e) => handleChange(key, 'date', e.target.value)}
                  disabled={disabled || readOnly}
                  readOnly={readOnly}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
